import { baseApi } from './baseApi';

export interface GetAllVitalsParams {
  pageNo: number;
  pagesize: number;
  pagination_required: boolean;
  patient_id?: string;
  org_id?: string;
}

export const vitalsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllVitals: build.query<any, GetAllVitalsParams>({
      query: ({ pageNo, pagesize, pagination_required, patient_id, org_id }) => ({
        url: '/vital/getAllVitals',
        params: { pageNo, pagesize, pagination_required, patient_id, org_id },
        method: 'GET',
      }),
      providesTags: ['KeyLicenses'],
    }),
    getVitalPdf: build.query<Blob, string>({
      query: (vital_id) => ({
        url: `/vital/getVitalPdf/${vital_id}`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
        cache: 'no-cache',
      }),
    }),
    sendToSabai: build.mutation<any, string>({
      query: (vital_id) => ({
        url: `/vital/sendToSabai/${vital_id}`,
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetAllVitalsQuery, useLazyGetVitalPdfQuery, useSendToSabaiMutation } = vitalsApi;
